import { render, staticRenderFns } from "./DesignDataForm.vue?vue&type=template&id=1c3f694d"
import script from "./DesignDataForm.vue?vue&type=script&lang=js"
export * from "./DesignDataForm.vue?vue&type=script&lang=js"
import style0 from "./DesignDataForm.vue?vue&type=style&index=0&id=1c3f694d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports